import { isLogin } from '@/shared/user';
import { jumpVipUrl } from '@/api/comm'


/**
 * VIP页面跳转工具类
 */
const VipJumpUtil = {
  /**
   * 跳转到VIP页面
   * @param {Object} context - Vue组件实例上下文(this)，用于访问$loading和消息提示
   * @param {Function} successCallback - 成功回调
   * @param {Function} errorCallback - 失败回调
   */
  jumpToVip(context, successCallback, errorCallback) {
    if (!isLogin()) {
      this.handleNotLogin();
    } else {
      this.handleLoggedIn(context, successCallback, errorCallback);
    }
  },

  /**
   * 处理未登录状态
   */
  handleNotLogin() {
    const vipUrl = localStorage.getItem('vipUrl');
    if (vipUrl) {
      window.open(vipUrl, '_blank');
    } else {
      console.warn('未找到VIP页面地址');
      // 可以在这里添加默认处理，比如跳转到登录页
      // showLogin();
    }
  },

  /**
   * 处理已登录状态
   * @param {Object} context - Vue组件实例上下文
   * @param {Function} successCallback - 成功回调
   * @param {Function} errorCallback - 失败回调
   */
  async handleLoggedIn(context, successCallback, errorCallback) {
    // 显示加载状态
    const loading = context.$loading({
      lock: true,
      text: '跳转中，请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    try {
      // 调用接口获取跳转地址
      const response = await jumpVipUrl();
      const url = response.data?.url;
      
      if (url) {
        window.open(url, '_blank');
        // 执行成功回调
        if (typeof successCallback === 'function') {
          successCallback(url);
        }
      } else {
        throw new Error('未获取到有效的VIP页面地址');
      }
    } catch (error) {
      console.error('VIP页面跳转失败:', error);
      // 显示错误消息
      context.$message.error('跳转失败，请稍后重试');
      // 执行错误回调
      if (typeof errorCallback === 'function') {
        errorCallback(error);
      }
    } finally {
      // 关闭加载状态
      loading.close();
    }
  }
};

export default VipJumpUtil;
